exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".food_menu[data-v-46f5d4ac]{text-align:center}.col[data-v-46f5d4ac]{height:445px}.col[data-v-46f5d4ac]:nth-child(2n-1){text-align:right}.col[data-v-46f5d4ac]:nth-child(2n){text-align:left}.col .img1[data-v-46f5d4ac],.col .img2[data-v-46f5d4ac],.col .img3[data-v-46f5d4ac],.col .img4[data-v-46f5d4ac]{display:inline-block;padding:5px;height:100%;box-sizing:border-box}.col .img1[data-v-46f5d4ac]{border-right:3px solid #7d7d7d;border-bottom:3px solid #7d7d7d}.col .img2[data-v-46f5d4ac]{border-left:3px solid #7d7d7d;border-bottom:3px solid #7d7d7d}.col .img3[data-v-46f5d4ac]{border-right:3px solid #7d7d7d;border-top:3px solid #7d7d7d}.col .img4[data-v-46f5d4ac]{border-left:3px solid #7d7d7d;border-top:3px solid #7d7d7d}.col img[data-v-46f5d4ac]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46f5d4ac","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/private/food_menu.vue
// module id = 551
// module chunks = 0